import { Theme } from "theme/themeTypes";

export const darkTheme: Theme = {
  primary: "#5d46e5",
  bodyBg: "#23222e",
  contentBg: "#282537",
  text: "#8e8a9c",
  header: "#ffffff",
  inputBg: "#201e29",
  transparentInputBg: "#201e29",
  inputBorder: "#201e29",
  offRangeBg: "#322e49",
  calendarBorder: "#403960",
  calendarCellText: "#8e8a9c",
  calendarHeaderText: "#8e8a9c",
  calendarTodayBg: "#282537",
  menuItemText: "#8e8a9c",
  menuItemHover: "#282537",
  menuItemSelected: "#322e49",
  triggerBg: "#322e49",
  avatarBg: "#282537",
  profileAvatarBg: "#322e49",
  cardBg: "#322e49",
  title: "#8e8a9c",
  placeholder: "#4d4477",

  formPlaceholder: "#3b3847",
  stepBg: "#201e29",
  stepIcon: "white",
  completedStepIcon: "#8e8a9c",
  stepSeperator: "white",
  completedStepBorder: "#8e8a9c",
};
